export const CONFIRM_ORDER_ACTION = "CONFIRM_ORDER";
